<template>
  <div>
    <div
      class="item coll2 comWrapper card mt-2 mb-2 p-3"
      v-for="(item, index) in viewData"
      :key="index"
    >
      <div class="comWrapper-wrapper van-hairline--bottom">
        <span style="background: #f44336"></span>
        {{ item[列[0].field] }}
      </div>
      <van-cell-group>
        <template v-for="(col, idx) in 列">
          <van-cell
            v-if="idx > 0 && col.field != 'detail'"
            :key="'col_' + idx"
            :title="col.title"
            :value="item[col.field]"
          />
          <van-cell
            @click="viewDetail(item)"
            v-if="idx > 0 && col.field == 'source'"
            :key="'col_' + idx"
          >
            <template #extra>
              <div class="van-cell__value center">
                查看动产抵押详情
              </div>
            </template>
          </van-cell>
        </template>
      </van-cell-group>
    </div>
  </div>
</template>

<script>

export default {
  name: "chattelMortgageCheck",
  components: {
  },
  props: ["data"],
  data(){
    return{
      列:[
        { title: "登记编号", field: "registerNo" },
        { title: "登记时间", field: "registerDate" },
        { title: "登记机关", field: "registerOffice" },
        { title: "被担保债权数额", field: "debtSecuredamount" },
        { title: "状态", field: "status" },
        { title: "债务人信息", field: "debtorInfo" },
        { title: "动产抵押详细信息", field: "detail" }
      ],
      页码: 1,
      每页数据量: 10,
      innerVisible: false,
      viewData: [],
      detailData: {
        pledge:{
          registNo: "",
          registOffice: "",
          registDate: ""
        },
        pledgeeList:[],
        securedClaim:{
          kind: "",
          amount: "",
          assuranceScope: "",
          fulfillObligation: "",
          remark: ""
        },
        guaranteeList:[],
        cancelInfo:{
          cancelDate: "",
          cancelReason: ""
        },
        changeList:[]
      },
      pledgeListCol:[
        { title: "名称", field: "name" },
        { title: "抵押权人证照类型", field: "identityType" },
        { title: "证件号码", field: "identityNo" }
      ],
      guaranteeListCol:[
        { title: "名称", field: "name" },
        { title: "所有权或使用权归属", field: "ownership" },
        { title: "数量、质量、状况、所在地等情况", field: "other" },
        { title: "备注", field: "remark" },
        { title: "所有权或使用权归属信息", field: "keyNoList" }
      ],
      changeListCol:[
        { title: "动产抵押登记变更日期", field: "changeDate" },
        { title: "动产抵押登记变更内容", field: "changeContent" }
      ]
    }
  },
  computed:{

  },
  methods:{
    viewDetail(row){
      window.localStorage.setItem(
        "risk_detail_data",
        JSON.stringify(row)
      );

      this.$router.push({
        name: "ScanSubDetail",
        query: {
          key: 'chattelMortgageCheck'
        },
      });
    },
    pagination(){
      this.viewData = this.data;
    }
  },
  created() {
    this.pagination();
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
@import "./style.scss";
</style>